import React from 'react';

import PiiObfuscator from 'src/components/pii-obfuscator';
import CurrencyFormat from 'src/transformer/currency-format';
import { useSelector } from 'react-redux';
import { convertPenniesToDecimals } from "src/utils/money";
import domain from 'src/config/domain';

const TopMerchants = ({ data, loading }) => {
  const { enums } = useSelector((state) => state.enums);
  const domainConfig = domain();

  if (loading || !data?.stats?.merchants?.top_ten || data?.stats?.merchants?.top_ten.length === 0) {
    return <React.Fragment />;
  }

  return (
    <div className="col-span-6 mt-2" id="expiredopenbanking">
      <div className="flex flex-col rounded-md border border-slate-200 animate-in fade-in-50 bg-gray-50">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title w-100">
              <div className={`float-right inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-md text-xs font-medium border ${domainConfig.styles.borderColour} ${domainConfig.styles.lightBGColour} ${domainConfig.styles.textColour}`}>
                last 30 days
              </div>
              <h2 className={`text-xl font-normal ${domainConfig.styles.textColour}`}>
                Top <span className="font-bold"> Merchants</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="relative pt-14 lg:pt-0">
          <div className="col-span-6 rounded-md animate-in fade-in-50">
            <div className="nk-block">
              <div className="card">
                <div className="card-inner-group">
                  <div className="card-inner p-0">
                    <table className="table table-tranx">
                      <thead>
                      <tr className="tb-tnx-head text-left">
                          <th className="text-left border-r border-r" rowSpan={2}>
                            <span>Organisation</span>
                          </th>
                          <th className="text-center" colSpan={2}>
                            <span>Payments</span>
                          </th>
                        </tr>
                        <tr className="tb-tnx-head text-left">
                          <th className="text-center">
                            <span>Count</span>
                          </th>
                          <th className="text-center border-l">
                            <span>Total</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.stats?.merchants?.top_ten.map((item, key) => (
                          <tr className="tb-tnx-item cursor-pointer hover:bg-gray-50" key={key}>
                            <td className="text-left border-r">
                              <PiiObfuscator className="font-bold" type="company">{item.organisation_name}</PiiObfuscator> <br/>{item.organisation_id}
                            </td>
                            <td className="text-center">
                                {item.payment_count}
                            </td>
                            <td className="text-center border-l">
                              {CurrencyFormat(enums.currency, 'GBX').format(convertPenniesToDecimals(item.total))}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <span />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopMerchants;